export default "__VITE_ASSET__DWE0Cj68__"